import React from "react";
import WaveSurfer from "wavesurfer.js";
import "./Works.css";
import Player from "./Player";

const Works = () => {
    const audioTracks = [
        { id: 1, path: "/Audio/01.mp3", title: "Swimming in the City", composer: "アオヤマタロウ", genre: "R&B", comment: "R&B調のポップスです。" },
        { id: 2, path: "/Audio/02.mp3", title: "夢の続きを", composer: "アオヤマタロウ", genre: "Pop", comment: "ちょっと切ないポップスです。" },
        { id: 3, path: "/Audio/03.mp3", title: "今すぐ会いたい", composer: "アオヤマタロウ", genre: "Old Rock", comment: "GS風ロックです。" },
        { id: 4, path: "/Audio/04.mp3", title: "忘れられないの", composer: "アオヤマタロウ", genre: "Pop Rock", comment: "古い日本の歌謡ロック調です。" },
        { id: 5, path: "/Audio/05.mp3", title: "夜明けのバス", composer: "アオヤマタロウ", genre: "Blues", comment: "R&B調ブルースです。" },
        { id: 6, path: "/Audio/06.mp3", title: "メランコリックな恋", composer: "アオヤマタロウ", genre: "Old Pop", comment: "ちょっと懐かしい感じの日本語ポップスです。" }
    ];

    return (
        <div className="works-wrapper">
            <div className="works-title-wrapper">
                <span className="works-title-text">
                    Works
                </span>
            </div>

            <section className="works-music-wrapper">
                <div className="works-music-title">
                    <span className="works-music-title-text">
                        Sample Tracks
                    </span>
                </div>
                <div className="player-wrapper-outside">
                    {audioTracks.map((track) => (
                        <div key={track.id} className="player-wrapper">

                            <div className="works-audio-information">
                                <div className="row1 bs">ID</div>
                                <div className="row2 bd">{track.id}</div>
                                <div className="row3 bs">TITLE</div>
                                <div className="row4 bd">{track.title}</div>
                                <div className="row5 bs">ARTIST</div>
                                <div className="row6 bd">{track.composer}</div>
                                <div className="row7 bs">GENRE</div>
                                <div className="row8">{track.genre}</div>
                            </div>
                            <Player audioFile={track.path} />
                            <div className="track-comment">
                                <span className="track-comment-text">{track.comment}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div >

    )

};

export default Works;
